import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';

// 1. 영화 객체 타입 정의
interface Movie {
  Title: string;
  Year: string;
  imdbID: string;
  Type: string;
  Poster: string;
}

// 2. API 응답 타입 정의
interface SearchResponse {
  Search?: Movie[];
  totalResults?: string;
  Response: string;
  Error?: string;
}

export default function Movies() {
    const [title, setTitle] = useState<string>('');
    // 3. movies 상태에 Movie 배열 타입 지정
    const [movies, setMovies] = useState<Movie[]>([]);

    async function fetchMovies(): Promise<void> {
        if (!title.trim()) return;

        try {
            const res = await fetch(`https://www.omdbapi.com/?apikey=7035c60c&s=${title}`);
            const data: SearchResponse = await res.json();
            
            // 결과가 없을 경우 빈 배열 처리
            const searchResult = data.Search || []; 
            setMovies(searchResult);
        } catch (error) {
            console.error("영화 검색 중 에러 발생:", error);
        }
    }

    return (
    <>
        <h1>Movies</h1>
        <input
            value={title}
            placeholder="영화 제목을 입력하세요"
            // 4. 이벤트 객체 타입은 자동으로 추론되나 필요한 경우 명시 가능
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => { 
                if (e.key === 'Enter') fetchMovies(); 
            }}
        />
        <button onClick={fetchMovies}>Search</button>
        
        <ul>
            {movies.map(movie => (
                <li key={movie.imdbID}>
                    {/* movie 객체의 속성(imdbID, Title)을 안전하게 사용 가능 */}
                    <Link to={`/movies/${movie.imdbID}`}>{movie.Title}</Link>
                </li>
            ))}
        </ul>

        {/* 중첩 라우트(상세 정보)가 표시될 자리 */}
        <Outlet />
    </>
    );
}